export const REACT_PAGE_INTRO = 0
export const REACT_PAGE_MAIN_ALIGN = 1
export const REACT_PAGE_MAIN = 2
export const REACT_PAGE_LOOKS_CLASSIC = 3
export const REACT_PAGE_LOOKS_EYES = 4
export const REACT_PAGE_LOOKS_LIPS = 5
export const REACT_PAGE_LIPS = 6
export const REACT_PAGE_EYES = 7
export const REACT_PAGE_BLUSH = 8
export const REACT_PAGE_PLUMP = 9
export const REACT_PAGE_PALETTE = 10
export const REACT_PAGE_VTO_ENTRY = 11
export const REACT_PAGE_VTO = 12
export const REACT_PAGE_CART = 13
export const REACT_PAGE_FINAL_CHECKOUT = 14
export const REACT_PAGE_EXIT_ALERT = 15
export const REACT_PAGE_EXIT = 16

// This is the order in which the lipsticks are displayed in the VTO.
// This provides an index into any of:
// SHADE_PRODUCT_IDS
// SHADE_CMS_CODES
// shadeImages
// Which contain more detail about each shade.
export const SHADES_ARRAY = [1, 2, 3, 4, 5, 6, 7,
                             8, 9, 10, 11, 12, 13, 14,
                             15, 16, 17, 18, 19, 20, 21]


export const SHADE_PRODUCT_IDS = [0, 24, 25, 23, 26, 27, 18, 21,
                                  22, 28, 19, 29, 30, 31, 32,
                                  33, 34, 20, 35, 36, 37, 6]

function fyShuffle(arr) {
  let i = arr.length;
  while (--i > 0) {
    let randIndex = Math.floor(Math.random() * (i + 1));
    [arr[randIndex], arr[i]] = [arr[i], arr[randIndex]];
  }
  return arr;
}

// This will be shuffled in a different order each time the app is loaded.
export const SHADES_ARRAY_SHUFFLED = fyShuffle(SHADES_ARRAY)

/* Set these to match the CMS codes for each lipstick, as configured in the Holition CMS.
   These use codes that were already populated in the Holition CMS.
   Codes to be fixed up when the CMS data is all entered */
export const SHADE_CMS_CODES = ["",
                                "27626",  // 100 Posie K                                
                                "27628",  // 102 Extraordinary
                                "27627",  // 103 Better Not Pout
                                "27633",   // 300 Koko K
                                "27629",  // 301 Angel
                                "27630",  // 302 Snow Way Bae
                                "27631",  // 400 Boss
                                "27632",  // 401 Victoria
                                "27647",  // 402 Mary Jo K
                                "27634",  // 403 Bite Me
                                "27635",  // 503 Bad lil thing
                                "27636",  // 504 Hollyberry
                                "27637",  // 505 Autumn
                                "27638",  // 600 Twenty
                                "27639",  // 700 Bare
                                "27640",  // 701 Exposed
                                "27641",  // 704 Sweater Weather
                                "27642",  // 800 One Wish
                                "27643",  // 801 Queen                               
                                "27645",  // 802 Candy K
                                "27646"]  // 808 Kylie
                              
export const SKU_CODES =  ["",  // Empty Look
                           "4064941006923",  // 100 Posie K                                
                           "4064941006893",  // 102 Extraordinary
                           "4064941006916",  // 103 Better Not Pout
                           "4064941006824",   // 300 Koko K
                           "4064941006794",  // 301 Angel
                           "4064941006800",  // 302 Snow Way Bae
                           "4064941008583",  // 400 Boss
                           "4064941008576",  // 401 Victoria
                           "4064941008569",  // 402 Mary Jo K
                           "4064941008552",  // 403 Bite Me
                           "4064941006787",  // 503 Bad lil thing
                           "4064941006732",  // 504 Hollyberry
                           "4064941006756",  // 505 Autumn
                           "4064941006701",  // 600 Twenty
                           "4064941008675",  // 700 Bare
                           "4064941008651",  // 701 Exposed
                           "4064941008682",  // 704 Sweater Weather
                           "4064941006664",  // 800 One Wish
                           "4064941006688",  // 801 Queen                               
                           "4064941006671",  // 802 Candy K
                           "4064941006657"]  // 808 Kylie                                

export const ALERT_NONE = 0
export const ALERT_EXIT = 1


/* We probably need an array of prices.  Or maybe prices don't vary by shade - wait to confirm */
export const PRICE = "£24.99"

export const PRODUCTS = [
  // 0
  {
    name: 'CHOOSE A SHADE...',
    shortName: 'TAP A SHADE',
    image: null,
    productid: "", 
    catentry: "",
    price: "£0.00"
  },
  // 1 -- info done
  {
    name: 'MATTE BLUE KYLINER GEL PENCIL',
    image: 'bluegelpencil',
    productid: "10303507006",
    catentry: "2613957",
    price: "£24.99"
  },
  // 2 -- info done
  {
    name: 'KOKO K MATTE LIQUID LIPSTICK',
    image: 'mattelipstick',
    productid: "10303437016",
    catentry: "2613776",
    price: "24.99"
  },
  // 3 - info done
  { 
    name: 'MEDIUM BROWN KYBROW PENCIL' ,
    image: 'brownpencil',
    productid: "10303510004",
    catentry: "2613978",
    price: "£24.99"
  },
  // 4 -- info done
  {
    name: 'WINTER KISSED PRESSED BLUSH POWDER',
    image: 'winterpowder',
    productid: "10303506003",
    catentry: "2613948",
    price: "£24.99"
  },
  // 5 - info done
  {
    name: 'BLACK KYLINER LIQUID PEN',
    image: 'blackpen',
    productid: "10303509001",
    catentry: "2613973",
    price: "£24.99"
  },
  // 6 - info done
  {
    name: 'KYLIE MATTE LIP KIT',
    shortName: 'KYLIE',
    image: 'mattelipkit',
    productid: "10303437004",
    catentry: "2613764",
    price: "£24.99"
  },
  // 7 - info done
  {
    name: 'BADDIE ON THE BLOCK PRESSED BLUSH POWDER',
    image: 'baddiepowder',
    productid: "10303506006",
    catentry: "2635688",
    price: "£24.99"
  },
  // 8 - info done
  {
    name: 'COOL BROWN KYBROW PENCIL',
    image: 'coolbrownpencil',
    productid: "10303510003",
    catentry: "2613977",
    price: "£24.99"
  },
  // 9 - info done
  {
    name: 'DIVA HIGH GLOSS',
    image: 'divagloss',
    productid: "10303511003",
    catentry: "2613984",
    price: "£24.99"
  },
  // 10 -- info done
  {
    name: 'TEQUILA TAN PRESSED BRONZING POWDER',
    image: 'tequilapowder',
    productid: "10303503003",
    catentry: "2633594",
    price: "£24.99"
  },
  // 11 - info done
  {
    name: 'PINK POWER PRESSED BLUSH POWDER',
    image: 'pinkpowder',
    productid: "10303506001",
    catentry: "2613946",
    price: "£24.99"
  },
  // 12 - info done
  {
    name: 'CRUSH PRESSED BLUSH POWDER',
    image: 'crushpowder',
    productid: "10303506002",
    catentry: "2613947",
    price: "£24.99"
  },
  // 13 -- missing
  {
    name:'KITTEN BABY PRESSED BLUSH POWDER',
    image: 'kittenpowder',
    productid: "10303506004",
    catentry: "2613949",
    price: "£24.99"
  },
  // 14 - info done
  {
    name:'AUBURN KYBROW PENCIL',
    image: 'auburnpencil',
    productid: "10303510002",
    catentry: "2613976",
    price: "£24.99"
  },
  // 15 -- info done
  {
    name:'DEEP BROWN KYBROW PENCIL',
    image: 'deeppencil',
    productid: "10303510005",
    catentry: "2613979",
    price: "£24.99"
  },
  // 16 -- info done
  {
    name:'BLONDE KYBROW PENCIL',
    image: 'blondepencil',
    productid: "10303510001",
    catentry: "2613975",
    price: "£24.99"
  },
  // 17 -- info done
  {
    name:'EBONY KYBROW PENCIL',
    image: 'ebonypencil',
    productid: "10303510006",
    catentry: "2613980",
    price: "£24.99"
  },
  // 18 -- info done
  {
    name:'SNOW WAY BAE MATTE LIP KIT',
    shortName: 'SNOW WAY BAE',
    image: 'snowlipkit',
    productid: "10303437018",
    catentry: "2613778",
    price: "£24.99"
  },
  // 19 -- info done
  {
    name:'BITE ME MATTE LIP KIT',
    shortName: 'BITE ME',
    image: 'bitelipkit',
    productid: "10303437015",
    catentry: "2613775",
    price: "£24.99"
  },
  // 20 -- info done
  {
    name:'SWEATER WEATHER MATTE LIP KIT',
    shortName: 'SWEATER WEATHER',
    image: 'sweaterlipkit',
    productid: "10303437007",
    catentry: "2613767",
    price: "£24.99"
  },
  // 21 -- info done
  {
    name:'BOSS MATTE LIP KIT',
    shortName: 'BOSS',
    image: 'bosslipkit',
    productid: "10303437012",
    catentry: "2613772",
    price: "£24.99"
  },
  // 22 -- info done
  {
    name:'VICTORIA MATTE LIP KIT',
    shortName: 'VICTORIA',
    image: 'victorialipkit',
    productid: "10303437013",
    catentry: "2613773",
    price: "£24.99"
  },
  // 23 -- info done
  {
    name:'BETTER NOT POUT MATTE LIP KIT',
    shortName: 'BETTER NOT POUT',
    image: 'betternotpout',
    productid: "10303437021",
    catentry: "2613781",
    price: "£24.99"
  },
  // 24 -- info done
  {
    name:'POSIE K MATTE LIP KIT',
    shortName: 'POSIE K',
    image: '',
    productid: "10303437019",
    catentry: "2613779",
  },
  // 25 -- info done
  {
    name:'EXTRAORDINARY MATTE LIP KIT',
    shortName: 'EXTRAORDINARY',    
    image: '',
    productid: "10303437020",
    catentry: "2613780",
  },
  // 26 -- info done
  {
    name:'KOKO K MATTE LIP KIT',
    shortName: 'KOKO K',
    
    image: '',
    productid: "10303437016",
    catentry: "2613776",
  },
  // 27 -- info done
  {
    name:'ANGEL MATTE LIP KIT',
    shortName: 'ANGEL',    
    image: '',
    productid: "10303437017",
    catentry: "2613777",
  },
  // 28 -- info done
  {
    name:'MARY JO K MATTE LIP KIT',
    shortName: 'MARY JO K',    
    image: '',
    productid: "10303437014",
    catentry: "2613774",
  },
  // 29 -- info done
  {
    name:'BAD LIL THING MATTE LIP KIT',
    shortName: 'BAD LIL THING',    
    image: '',
    productid: "10303437009",
    catentry: "2613769",
  },
  // 30 -- info done
  {
    name:'HOLLYBERRY MATTE LIP KIT',
    shortName: 'HOLLYBERRY',    
    image: '',
    productid: "10303437010",
    catentry: "2613770",
  },
  // 31 -- info done
  {
    name:'AUTUMN LIP KIT',
    shortName: 'AUTUMN',    
    image: '',
    productid: "10303437011",
    catentry: "2613771",
  },
  // 32 -- info done
  {
    name:'TWENTY MATTE LIP KIT',
    shortName: 'TWENTY',    
    image: '',
    productid: "10303437008",
    catentry: "2613768",
  },
  // 33 -- info done
  {
    name:'BARE MATTE LIP KIT',
    shortName: 'BARE',    
    image: '',
    productid: "10303437005",
    catentry: "2613765",
  },
  // 34 -- info done
  {
    name:'EXPOSED MATTE LIP KIT',
    shortName: 'EXPOSED',    
    image: '',
    productid: "10303437006",
    catentry: "2613766",
  },
  // 35 -- info done
  {
    name:'ONE WISH MATTE LIP KIT',
    shortName: 'ONE WISH',    
    image: '',
    productid: "10303437001",
    catentry: "2613761",
  },
  // 36 -- info done
  {
    name:'QUEEN MATTE LIP KIT',
    shortName: 'QUEEN',    
    image: '',
    productid: "10303437002",
    catentry: "2613762",
  },
  // 37 -- info done
  {
    name:'CANDY K MATTE LIP KIT',
    shortName: 'CANDY K',    
    image: '',
    productid: "10303437003",
    catentry: "2613763",
  },
   // 38 -- info done
   {
    name:'BUBBLY PLUMPING GLOSS LIPGLOSS',
    shortName: 'BUBBLY',    
    image: 'bubblypg',
    productid: "10320299006",
    catentry: "2746114", 
  },
  // 39 -- info done
  {
    name:'ROSÉ AND CHILL PLUMPING GLOSS LIPGLOSS',
    shortName: 'ROSÉ AND CHILL',    
    image: 'roseandchillpg',
    productid: "10320299002",
    catentry: "2746110",
  },
  // 40 -- info done
  {
    name:'ON NEUTRAL PLUMPING GLOSS LIPGLOSS',
    shortName: 'ON NEUTRAL',    
    image: 'onneutralpg',
    productid: "10320299005",
    catentry: "2746113",
  },
  // 41 -- info done
  {
    name:'NOT YOUR BAE PLUMPING GLOSS LIPGLOSS',
    shortName: 'NOT YOUR BAE',    
    image: 'notyourbaepg',
    productid: "10320299004",
    catentry: "2746112",
  },
  // 42 -- info done
  {
    name:'MOODY QUEEN PLUMPING GLOSS LIPGLOSS',
    shortName: 'MOODY QUEEN',    
    image: 'moodyqueenpg',
    productid: "10320299001",
    catentry: "2746109",
  },
  // 43 -- info done
  {
    name:'CURVE HIM PLUMPING GLOSS LIPGLOSS',
    shortName: 'CURVE HIM',    
    image: 'curvehimpg',
    productid: "10320299003",
    catentry: "2746111",
  },
  // 44 -- info missing
  {
    name:'BRONZE PALETTE',
    shortName: 'BRONZE PALETTE',    
    image: 'bronzepalette',
    productid: "10313568",
    catentry: "2688183",
  },
  // 45 -- info missing
  {
    name:'MAUVE PALETTE',
    shortName: 'MAUVE PALETTE',    
    image: 'mauvepalette',
    productid: "10313569",
    catentry: "2688185",
  },
]